import { takeLatest, call, put, all } from "redux-saga/effects";
import * as types from "./types";
import { setLocalesData } from "./actions";
import api from "app/services/api";
import objectToQueryString from "app/utils/objectToQueryString";
import ToastService from "../../../services/ToastService";

export function* create({ payload }) {
  const { formData, callback } = payload;
  try {
    yield put({
      type: types.CREATE,
    });
    yield call(api.post, "/locales", formData);
    yield put({
      type: types.CREATE_SUCCESS,
    });
    ToastService.showSuccess("localesList.successCreate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.CREATE_FAIL,
    });
  }
}

export function* read({ payload }) {
  try {
    yield put({
      type: types.READ,
    });
    const { data } = yield call(
      api.get,
      `/locales${objectToQueryString({ ...payload })}`
    );

    yield put(setLocalesData(data));
    yield put({
      type: types.READ_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: types.READ_FAIL,
    });
  }
}

export function* update({ payload }) {
  const { id, formData, callback } = payload;
  try {
    yield put({
      type: types.UPDATE,
    });
    yield call(api.put, `/locales/${id}`, formData);
    yield put({
      type: types.UPDATE_SUCCESS,
    });
    ToastService.showSuccess("localesList.successUpdate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.UPDATE_FAIL,
    });
  }
}

export function* inactivate({ payload }) {
  const { id, callback } = payload;
  try {
    yield put({
      type: types.DELETE,
    });
    yield call(api.delete, `/locales/${id}`);
    yield put({
      type: types.DELETE_SUCCESS,
    });
    ToastService.showSuccess("localesList.successInactivate");
    callback();
  } catch (error) {
    ToastService.showApiRequestError(error);
    yield put({
      type: types.DELETE_FAIL,
    });
    callback();
  }
}

export default all([
  takeLatest(types.REQUEST_CREATE, create),
  takeLatest(types.REQUEST_READ, read),
  takeLatest(types.REQUEST_UPDATE, update),
  takeLatest(types.REQUEST_DELETE, inactivate),
]);
